/* Schnell hinzufügen: kompakte Set-Auswahl – 7 O'CLOCK
   Angelegt: 2026-09-28

   Zeigt im Quick-Add-Modal der Produktkarten die Set-Staffeln der
   Sectionheroes-Bundle-App (2er / 4er / 6er Set …) als kompakte Auswahl.
   Rabatt-Badge oben rechts an der Outline, Preis darunter reagiert auf
   die Auswahl, „In den Warenkorb" legt das gewählte Set mit denselben
   Line-Item-Properties wie die Produktseite ab – der App-Rabatt greift
   dadurch automatisch im Warenkorb.

   Datenquelle: templates/product.oc-sets.json (nur der Bundle-App-Block,
   ohne Layout), abgerufen per /products/<handle>?view=oc-sets.

   Bewusst als Laufzeit-Enhancement, damit snippets/product_item_new*.liquid
   unverändert bleiben. Produkte mit echten Varianten (Größenauswahl im
   Modal) und Produkte ohne Bundle-Staffel bleiben wie bisher.

   Styles: assets/custom-quick-add-sets.css
   Eingebunden über snippets/gtm-head.liquid. */
(function () {
  'use strict';

  var VIEW = 'oc-sets';
  var cache = {};

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function moneyToCents(text) {
    if (!text) return null;
    var m = String(text).replace(/\s/g, '').match(/(\d{1,3}(?:\.\d{3})+|\d+),(\d{2})/);
    if (!m) return null;
    return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
  }

  function formatMoney(cents) {
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1] + ' €';
  }

  function parseConfig(html) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var script = doc.querySelector('script[data-bundle-config]');
    if (!script) return null;

    var cfg;
    try { cfg = JSON.parse(script.textContent); } catch (e) { return null; }
    if (!cfg || !cfg.shortId || !Array.isArray(cfg.offers) || cfg.offers.length < 2) return null;

    var offers = [];
    for (var i = 0; i < cfg.offers.length; i++) {
      var o = cfg.offers[i] || {};
      var block = doc.querySelector('[data-offer-index="' + (i + 1) + '"]');
      if (!block) return null;

      var qty = parseInt(block.getAttribute('data-quantity') || o.quantity, 10) || 1;
      var variantId = parseInt(block.getAttribute('data-variant-id'), 10);
      var base = parseInt(block.getAttribute('data-base-price'), 10);
      var baseCompare = parseInt(block.getAttribute('data-base-compare-price'), 10) || 0;
      if (!variantId || !base) return null;

      var dType = (o.discount && o.discount.type) || block.getAttribute('data-discount-type') || 'none';
      var dVal = parseFloat((o.discount && o.discount.value) || block.getAttribute('data-discount-value') || 0) || 0;

      var total = base;
      if (dType === 'percentage' && dVal > 0) {
        total = Math.round(base * (1 - dVal / 100));
      } else if (dType !== 'none' && dVal > 0) {
        var totalEl = block.querySelector('.sh-bundle-block-content-item-price-total');
        var shown = moneyToCents(totalEl && totalEl.textContent);
        if (shown && shown < base) total = shown;
      }

      var pct = 0;
      if (dType === 'percentage' && dVal > 0) pct = Math.round(dVal);
      else if (total < base) pct = Math.round((1 - total / base) * 100);

      offers.push({
        title: (o.content && o.content.title) || (qty + 'x'),
        qty: qty,
        variantId: variantId,
        total: total,
        compare: Math.max(base, baseCompare),
        pct: pct,
        preselect: !!o.preselect
      });
    }

    return { shortId: cfg.shortId, offers: offers };
  }

  function loadConfig(handle) {
    if (!handle) return Promise.resolve(null);
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=' + VIEW, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(parseConfig)
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  // Handle steht im x-show des umschließenden Modal-Blocks: modalHandle === '<handle>'
  function handleFor(opts) {
    var el = opts.parentElement;
    while (el && el !== document.body) {
      var xs = el.getAttribute && el.getAttribute('x-show');
      if (xs) {
        var m = xs.match(/modalHandle\s*===\s*'([^']+)'/);
        if (m) return m[1];
      }
      el = el.parentElement;
    }
    return null;
  }

  function render(opts, cfg) {
    var priceWrap = opts.querySelector('.product-card-new_modal-price-wrapper');
    if (!priceWrap) return false;

    var state = { cfg: cfg, index: 0 };
    for (var p = 0; p < cfg.offers.length; p++) {
      if (cfg.offers[p].preselect) { state.index = p; break; }
    }

    var group = document.createElement('div');
    group.className = 'oc-qa-sets';
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Setgröße');

    cfg.offers.forEach(function (offer, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'oc-qa-set';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('data-index', String(i));

      var name = document.createElement('span');
      name.className = 'oc-qa-set_name';
      name.textContent = offer.title;
      btn.appendChild(name);

      if (offer.pct > 0) {
        var badge = document.createElement('span');
        badge.className = 'oc-qa-set_badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = '-' + offer.pct + '%';
        btn.appendChild(badge);
        btn.setAttribute('aria-label', offer.title + ', du sparst ' + offer.pct + ' Prozent');
      }

      btn.addEventListener('click', function () { select(i); });
      group.appendChild(btn);
    });

    // Pfeiltasten wie bei einer Radio-Gruppe
    group.addEventListener('keydown', function (e) {
      var dir = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
      if (!dir) return;
      e.preventDefault();
      var next = (state.index + dir + cfg.offers.length) % cfg.offers.length;
      select(next);
      var nextBtn = group.querySelector('[data-index="' + next + '"]');
      if (nextBtn) nextBtn.focus();
    });

    var row = document.createElement('div');
    row.className = 'oc-qa-price-row';
    var priceEl = document.createElement('div');
    priceEl.className = 'product-card-new_modal-price';
    var cmpEl = document.createElement('s');
    cmpEl.className = 'product-card-new_modal-compare-price';
    var saveEl = document.createElement('span');
    saveEl.className = 'oc-qa-saving';
    row.appendChild(priceEl);
    row.appendChild(cmpEl);
    row.appendChild(saveEl);

    priceWrap.insertBefore(row, priceWrap.firstChild);
    priceWrap.classList.add('oc-qa-active');
    opts.insertBefore(group, priceWrap);

    function select(i) {
      state.index = i;
      var offer = cfg.offers[i];
      var buttons = group.querySelectorAll('.oc-qa-set');
      for (var k = 0; k < buttons.length; k++) {
        var on = k === i;
        buttons[k].classList.toggle('is-active', on);
        buttons[k].setAttribute('aria-checked', on ? 'true' : 'false');
        buttons[k].tabIndex = on ? 0 : -1;
      }
      var discounted = offer.compare > offer.total;
      priceEl.textContent = formatMoney(offer.total);
      priceEl.classList.toggle('is-discounted', discounted);
      cmpEl.textContent = discounted ? formatMoney(offer.compare) : '';
      cmpEl.hidden = !discounted;
      saveEl.textContent = discounted ? 'Du sparst ' + formatMoney(offer.compare - offer.total) : '';
      saveEl.hidden = !discounted;
    }

    opts.__ocSets = state;
    select(state.index);
    return true;
  }

  function init(opts) {
    // Produkte mit echten Varianten haben schon eine Größenauswahl
    if (opts.querySelector('.product-card-new_modal-sizes')) {
      opts.setAttribute('data-oc-sets', 'none');
      return;
    }
    var handle = handleFor(opts);
    if (!handle) {
      opts.setAttribute('data-oc-sets', 'none');
      return;
    }
    opts.setAttribute('data-oc-sets', 'loading');
    loadConfig(handle).then(function (cfg) {
      if (cfg && render(opts, cfg)) opts.setAttribute('data-oc-sets', 'done');
      else opts.setAttribute('data-oc-sets', 'none');
    });
  }

  function scan() {
    var list = document.querySelectorAll('.product-card-new_modal-options:not([data-oc-sets])');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getClientRects().length > 0) init(list[i]);
    }
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }

  function addSet(cta, state) {
    var offer = state.cfg.offers[state.index];
    if (!offer || cta.getAttribute('aria-busy') === 'true') return;
    cta.setAttribute('aria-busy', 'true');
    cta.disabled = true;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: offer.variantId,
          quantity: offer.qty,
          properties: {
            _bundle_set: offer.title,
            '_sh-bundle': JSON.stringify({ id: state.cfg.shortId, o: state.index })
          }
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var panel = cta.closest('.product-card-new_modal-panel');
        var close = panel && panel.querySelector('.product-card-new_modal-close');
        if (close) close.click();
        emit('cartupdated');
        emit('toggleminicart');
        emit('showcartmessage', { status: data.status, message: data.message, description: data.description });
      })
      .catch(function (err) {
        console.error('Schnell hinzufügen (Sets):', err);
      })
      .then(function () {
        cta.removeAttribute('aria-busy');
        cta.disabled = false;
      });
  }

  // Warenkorb-Button im Modal abfangen, sobald eine Set-Auswahl aktiv ist
  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest && e.target.closest('.product-card-new_modal-cta');
    if (!cta || cta.disabled) return;
    var opts = cta.closest('.product-card-new_modal-options');
    var state = opts && opts.__ocSets;
    if (!state) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    addSet(cta, state);
  }, true);

  // Nach jedem Klick (Modal öffnen, Farbe wechseln) sichtbare Modals prüfen
  document.addEventListener('click', function () {
    setTimeout(scan, 60);
    setTimeout(scan, 300);
    setTimeout(scan, 900);
  });

  // Daten schon beim Antippen des Warenkorb-Icons vorladen
  document.addEventListener('pointerdown', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-card-new_cart-button');
    if (!btn) return;
    var card = btn.closest('[data-product-handle]');
    if (card) loadConfig(card.getAttribute('data-product-handle'));
  }, { passive: true });

  /* Startbild im Quick-Add-Modal: Moodbild statt Freisteller (Ergänzung 28.09.2026).
     Gleiche Logik wie die Karte: Metafeld custom.sh_cp_moodimage, Standard = 2. Bild.
     Bis das Bild sitzt, blendet die CSS den Slider kurz aus (kein Springen). */
  document.documentElement.classList.add('oc-qa-js');

  function moodIndexFor(handle) {
    var cardSlider = document.querySelector('.product-card-new_slider[data-mood-index][x-ref="slider-' + handle + '"]');
    var n = cardSlider ? parseInt(cardSlider.getAttribute('data-mood-index'), 10) : 1;
    return isNaN(n) ? 1 : n;
  }

  function startOnMood(slider) {
    if (slider.__ocStart) return;
    slider.__ocStart = true;

    function done() { slider.setAttribute('data-oc-start', ''); }
    var slides = slider.querySelectorAll('.product-card-new_modal-slide');
    var index = Math.min(moodIndexFor(slider.getAttribute('data-modal-handle')), slides.length - 1);
    if (index < 1) { done(); return; }

    var img = slides[index].querySelector('img');
    if (img) {
      img.loading = 'eager';
      img.setAttribute('fetchpriority', 'high');
    }

    var tries = 0;
    function apply() {
      if (!slider.clientWidth && tries++ < 20) { requestAnimationFrame(apply); return; }
      slider.style.scrollSnapType = 'none';
      slider.scrollLeft = index * slider.clientWidth;
      requestAnimationFrame(function () {
        slider.scrollLeft = index * slider.clientWidth;
        slider.style.scrollSnapType = '';
        done();
      });
    }
    // Zwei Frames warten, bis das Theme seinen Reset auf Bild 1 erledigt hat
    requestAnimationFrame(function () { requestAnimationFrame(apply); });
    setTimeout(done, 1500);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList.contains('product-card-new_modal-slider')) {
            startOnMood(node);
          } else if (node.firstElementChild) {
            var inner = node.querySelectorAll('.product-card-new_modal-slider');
            for (var k = 0; k < inner.length; k++) startOnMood(inner[k]);
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
